import { render, staticRenderFns } from "./value-edition-goal-setting.component.vue?vue&type=template&id=0fc38448&scoped=true"
import script from "./value-edition-goal-setting.component.vue?vue&type=script&lang=ts"
export * from "./value-edition-goal-setting.component.vue?vue&type=script&lang=ts"
import style0 from "./value-edition-goal-setting.component.vue?vue&type=style&index=0&id=0fc38448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc38448",
  null
  
)

export default component.exports